import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { UserSessionService } from './../../../UserSession/user-session.service';
import { CustomEntityUtils } from './../../../custom-entity-utils.service';
import { CustomEntityService } from './../../../apiclient/api/customEntity.service';
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'ngx-elements-deleted',
  templateUrl: './elements-deleted.component.html',
  styleUrls: ['./elements-deleted.component.scss']
})
export class ElementsDeletedComponent implements OnInit {

  public reset: any[] = [{}];
  elementAttributesArray = [];
  elementSource: LocalDataSource = new LocalDataSource();
  userRole: [String] = ['manager'];
  initColumns= {
    name: {
      title: 'Nombre',
      type: 'string',
    }
  }

  settings = {

    noDataMessage:'No hay elementos',
    actions: {
      custom:[
        {
          name: 'restoreElement',
          title: '<i class="eva eva-external-link-outline" title="Restaurar elemento"></i>'
        }
      ],
      delete: false,
      add: false,
      edit:false,
      position: 'right',
      columnTitle:'',
    },

    columns: this.initColumns,

  };
  currentEntity: any;

  constructor(private userSessionService: UserSessionService,
    protected customEntityUtils: CustomEntityUtils,private datePipe: DatePipe,
     private customEntityService: CustomEntityService,
     private toastrService: NbToastrService) { }

  async ngOnInit() {

    this.userRole = this.userSessionService.user.acl_roles;
    this.currentEntity = await this.customEntityUtils.getCurrentEntity()

    this.settings.columns = JSON.parse(JSON.stringify(this.initColumns));

    for (let element of this.currentEntity.attributes.sort((a,b)=> {
      const posA = a.position != undefined ? a.position : 9999;
      const posB = b.position != undefined ? b.position : 9999;
      const sort = posA - posB;
      return sort;
    })) {
      this.settings.columns[element.id] = {title: element.name, type: 'string'}
    }


    this.elementAttributesArray = [];
    var currentElements = this.currentEntity.elements.filter( e => e.disabledAt != undefined);

    if(currentElements != undefined){
      for (let index = 0; index < currentElements.length; index++) {
        const element = currentElements[index].attributes;
        let elemento = new Object();
        elemento["id"] = currentElements[index].id;
        elemento["name"] = currentElements[index].name;

        this.currentEntity.attributes.forEach(atr => {
          if(element.find(a => a.id == atr.id) != undefined){
            elemento[atr.id] = element.find(a => a.id == atr.id).value;
          }
        })

        this.elementAttributesArray.push(elemento)
      }
    }

    //parametrizamos la smart table
    this.elementSource = new LocalDataSource();
    this.elementSource.load(this.elementAttributesArray.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));

    this.reset[0] = {};
  }

  public refresh(){
    this.ngOnInit();
  }

  /**
   * Recupera un elemento eliminado
  */
   restoreElement(event): void{
    this.customEntityService.updatecustomelementrestore(event.data.id,this.userSessionService.accessToken).subscribe(result => {
      this.userSessionService.invalidateCachedCustomEntities()
      this.userSessionService.invalidateCachedCustomEntityTypes()
      this.toastrService.success('El elemento se ha restaurado con éxito','Elemento restaurado');
      this.refresh();

    })
  }

}
